import { render, staticRenderFns } from "./ModalDiscar.vue?vue&type=template&id=79ad3c7d"
import script from "./ModalDiscar.vue?vue&type=script&lang=js"
export * from "./ModalDiscar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports